<template>
  <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
    <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px">
      <ion-item>
        <ion-label mode="md" class="ion-text-wrap">
          <h3>{{ title }}</h3>
          <p>{{ subtitle }}</p>
        </ion-label>
      </ion-item>
      <ion-card-content>
        <span class="h1 text-gold">{{ value }}</span>
        <span class="h4" style="margin-left: 5px">{{ unit }}</span>
      </ion-card-content>
    </ion-card>
  </slide-x-left-transition>
</template>

<script>
  export default {
    name: 'ItemStatistic',
    props: ['index', 'title', 'subtitle', 'value', 'unit'],
    data() {
      return {
        show: false
      }
    },
    mounted() {
      this.show = true
    },
  }
</script>